import "babel-polyfill";
import 'whatwg-fetch';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import AtComponents from 'at-ui'
import YmapPlugin from 'vue-yandex-maps'
import VueRouter from 'vue-router'
import router from "./router";
import { VueReCaptcha } from 'vue-recaptcha-v3'

// For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LfDxyEmAAAAAFwMu-z1lXNsKJkbW2ircV1IhLZM' })
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(AtComponents)

window._ = require('lodash')
window.Popper = require('popper.js').default
window.$ = window.jQuery = require('jquery')

Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Vue.axios.defaults.headers.common['Accept'] = 'application/json'

import store from './store';

// Подключаем модуль яндекс карт
const settings = {
  apiKey: 'ba0d0589-f903-43e9-b3d3-cc290988b69a',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1',
};

window.path = `${window.location.protocol}//${window.location.host}/`

window.hash = window.location.hash;

Vue.use(YmapPlugin, settings);

Vue.component('ymap', require('./components/spa/MapComponent.vue').default);

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router
});
